import { VerticalGroup, HorizontalGroup, Text, Button } from '@libs/uikit/Components';
import styled from 'styled-components';
import { HG } from './HG';
import { Link } from './Link';
import xmlFormat from 'xml-formatter';

const Pre = styled.pre`
    font-size: 12px;
    border-left: 4px solid #e2e2e2;
    overflow: scroll;
    max-width: 100%;
    background-color: aliceblue;
`;

export const General = ({ general, status, onCopyXml = () => {}, timeToPlay, duration }) => {
    const { xml, vpaidUrl, videoUrl, omidScripts = [], vpaid, wrappers } = general[0].payload.data;
    let adParameters;
    try {
        adParameters = vpaid.adParameters;
        adParameters = JSON.stringify(JSON.parse(adParameters), null, 2);
    } catch (e) {
        // Nothing to do
    }

    const onCopy = async () => {
        try {
            await navigator.clipboard?.writeText(`<VAST version="4.1">${xml}</VAST>`);
            onCopyXml();
        } catch (e) {
            alert('Your browsert does not support Clipboard API');
        }
    };

    let duraionString = '00:00';
    duraionString = (Math.floor(duration / 60)).toString().padStart(2, '0') + ':' + (duration % 60).toString().padStart(2, '0');

    return (
        <VerticalGroup>
            <VerticalGroup>
                <Text caption>Status:</Text> <Text info>{status}</Text>
            </VerticalGroup>
            {(+timeToPlay > 0) && <VerticalGroup>
                <Text caption>Time to fetch video asset:</Text> <Text info>{timeToPlay} seconds</Text>
            </VerticalGroup>}
            <VerticalGroup>
                <Text caption>Video duration:</Text> <Text info>{duraionString}</Text>
            </VerticalGroup>
            <VerticalGroup>
                <Text caption>Wrapped:</Text> <Text info>{wrappers.length - 1} times</Text>
            </VerticalGroup>
            {videoUrl && <VerticalGroup>
                <Text caption>Video Url:</Text> <Link href={videoUrl}>{videoUrl}</Link>
            </VerticalGroup>}
            {/* {vpaidUrl && <VerticalGroup>
                <Text caption>VPAID Url:</Text> <Link href={vpaidUrl}>{vpaidUrl}</Link>
            </VerticalGroup>}
            {adParameters && <VerticalGroup style={{ width: '100%', alignItems: 'baseline' }}>
                <Text caption>VPAID Ad Parameters:</Text> <Pre>{adParameters}</Pre>
            </VerticalGroup>} */}
            {omidScripts.length > 0 ? (
                <VerticalGroup style={{ width: '100%', alignItems: 'baseline' }}>
                    <Text caption>OMID:</Text>
                    {omidScripts.map((omidScript, id) => {
                        let parameters = omidScript.parameters;
                        try {
                            parameters = JSON.stringify(JSON.parse(parameters), null, 2);
                        } catch (e) {
                            // Nothing to do
                        }
                        return (
                            <VerticalGroup key={id}>
                                <HG style={{ width: '100%', alignItems: 'baseline' }}>
                                    <Text caption>VENDOR({id + 1}): {omidScript.vendor}</Text>
                                    <Text info>
                                        <sup>(<Link href={omidScript.resource}>{omidScript.resource}</Link>)</sup>
                                    </Text>
                                </HG>
                                {parameters !== 'null' && <Pre>{parameters}</Pre>}
                            </VerticalGroup>
                        );
                    })}
                </VerticalGroup>
            ) : null}
            <VerticalGroup style={{ width: '100%', alignItems: 'baseline' }}>
                <Text caption>VAST XML:</Text>
                <Pre>{xmlFormat(xml)}</Pre>
                <Button onClick={onCopy}>Copy XML</Button>
            </VerticalGroup>
        </VerticalGroup>
    );
};
